import { Component, Input } from '@angular/core';
import { ShimmerService } from 'src/app/core/services/common/shimmer.service';

@Component({
  selector: 'app-shimmer-loader',
  templateUrl: './shimmer-loader.component.html',
  styleUrls: ['./shimmer-loader.component.scss'],
  providers: [ShimmerService],
})
export class ShimmerLoaderComponent {
  @Input() radius: 'normal-radius' | 'no-radius';
  @Input() colorClass: 'orange' | 'green' = 'green';
}
